import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import moment from 'moment';
import {Table, Card, Dropdown, Loader, Popup, Icon} from 'semantic-ui-react';
import {ordersStatus} from '../../../common/dictionaries/accessories';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import {findValueInObjectsArray} from '../../../common/util/array';
import {pageSizes} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import ConfirmationModal from './ConfirmationModal';
import TablePaginator from '../../../common/components/tablePaginator';
import CancelOrder from '../../../accessories/components/orders/modal/cancel';
import {TasksDetailsModal} from './TasksDetailsModal';

const OFFSET = 0;

class QualityControlOrdersListTable extends Component {
  onPageClick(value) {
    const {pageSize, parameters} = this.props;
    this.props.changeListPage(value);
    this.props.fetchingQualityAssuranceOrdersList(parameters, pageSize, value);
  }

  onPageSizeClick(event, data) {
    const {parameters} = this.props;
    this.props.changeListPageSize(data.value);
    this.props.fetchingQualityAssuranceOrdersList(parameters, data.value, OFFSET);
  }

  onOrderCloseClick(order) {
    this.props.closeQualityAssuranceOrder(order);
  }

  renderStatusName(status) {
    const {orderStatusList} = this.props;
    if (!status) {
      return '';
    }
    return findValueInObjectsArray(orderStatusList, {'keySearch': 'id', 'valueSearch': status}, 'description');
  }

  renderLoaderOrSummary() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderDetail();
  }

  renderDetail() {
    const {list, orderStatusList} = this.props;
    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={9}>
            No hay información con los filtros seleccionados
          </Table.Cell>
        </Table.Row>
      );
    }

    return list.map((element, index) => {
      const dateFormatted = moment(element.creationDate).format(dateFormatShow);
      return (
        <Table.Row key={index} textAlign='center'>
          <Table.Cell>{element.order}</Table.Cell>
          <Table.Cell>{dateFormatted}</Table.Cell>
          <Table.Cell>{element.dealer}</Table.Cell>
          <Table.Cell>{element.location}</Table.Cell>
          <Table.Cell>{element.description}</Table.Cell>
          <Table.Cell>{element.chassis}</Table.Cell>
          <Table.Cell><TasksDetailsModal order={element} /></Table.Cell>
          <Table.Cell>
            {element.status}-{this.renderStatusName(element.status)}
          </Table.Cell>
          <Table.Cell>
            {element.qtyTasksOutsourced === 0 ? 'No' : 'Si'}
          </Table.Cell>
          <Table.Cell className='flex middle'>
            <Popup
              trigger={
                <Link
                  to={`/accesorios/pedidos-control-calidad/${element.order}/asignar-tareas`}
                >
                  <Icon
                    name='post_add'
                    color={element.tasks ? 'green' : 'blue'}
                    size='big'
                  />
                </Link>
              }
              content='Agregar Tareas'
              position='top center'
              inverted
            />
            <Popup
              trigger={
                <Link
                  to={`/accesorios/pedidos-control-calidad/${element.order}/asignar-partes`}
                >
                  <Icon
                    name='car_rental'
                    color={element.parts ? 'green' : 'blue'}
                    size='big'
                  />
                </Link>
              }
              content='Agregar Partes'
              position='top center'
              inverted
            />
            {(element.status === ordersStatus.assigned_technicians ||
              element.status === ordersStatus.closed_order ||
              element.status === ordersStatus.closed_order_not_billable) && (
              <ConfirmationModal
                key={element.order}
                order={element.order}
                orderStatusList={orderStatusList}
              />
            )}
            {element.status === ordersStatus.assigned_technicians && (
              <CancelOrder accessoryOrder={element} type='qualityAssurance' />
            )}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick.bind(this)}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick.bind(this)}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <Card fluid raised>
        <div className='horizontal-scroll'>
          <Table striped className='quality-assurance-table'>
            <Table.Header className='orders-table-header commercial-sticky-header'>
              <Table.Row textAlign='center'>
                <Table.HeaderCell>Orden</Table.HeaderCell>
                <Table.HeaderCell>Fecha Creación</Table.HeaderCell>
                <Table.HeaderCell>Cliente</Table.HeaderCell>
                <Table.HeaderCell>Ubicación</Table.HeaderCell>
                <Table.HeaderCell>Descripción</Table.HeaderCell>
                <Table.HeaderCell>Chasis</Table.HeaderCell>
                <Table.HeaderCell>Tareas</Table.HeaderCell>
                <Table.HeaderCell>Estado</Table.HeaderCell>
                <Table.HeaderCell>Subcontrato</Table.HeaderCell>
                <Table.HeaderCell>Acciones</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
        
            <Table.Body>
              {this.renderLoaderOrSummary()}
            </Table.Body>

            {this.renderPagination()}
          </Table>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.qualityAssuranceOrders.loadingOrders,
    'list': state.qualityAssuranceOrders.ordersList,
    'orderStatusList': state.accessoriesOrders.orderStatusList,
    'pageNumber': state.qualityAssuranceOrders.pageNumber,
    'pageSize': state.qualityAssuranceOrders.pageSize,
    'totalItems': state.qualityAssuranceOrders.itemsCount,
  };
};

const {
  fetchingQualityAssuranceOrdersList,
  closeQualityAssuranceOrder,
  changeListPage,
  changeListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  fetchingQualityAssuranceOrdersList,
  closeQualityAssuranceOrder,
  changeListPage,
  changeListPageSize,
})(QualityControlOrdersListTable);
